export const addRelated = (list) => {
  const relatedList = document.querySelector('[data-single-related-list]');

  if (relatedList)
    relatedList.appendChild(list)
}